export default "/assets/images/mila-feed-12-thumbnail.jpg?8a29e165fa12aa676869287fd0e2b177";